import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Dialog, DialogContent } from '@material-ui/core';
import { useStyles } from './styles';
import { Inquiry } from 'persona';
import { PersonaEnvironment, PersonaTemplateId } from '../../appConfig';
import { RootStoreContext } from '../../global/storeContext';

interface PersonaFields {
    firstname: string;
    lastname: string;
    dob: { year: number; month: number; day: number };
}

export const PersonaModal: React.FC<{
    person: PersonaFields;
    openVerificationModal: boolean;
    closeVerificationModal: () => void;
    onVerificationComplete: () => void;
}> = observer(
    ({ person, openVerificationModal, onVerificationComplete, closeVerificationModal }) => {
        const classes = useStyles();
        const { idVerificationStore, uiStore, userStore } = useContext(RootStoreContext);

        const closeModal = () => {
            onVerificationComplete();
        };

        return (
            <>
                <Dialog
                    open={openVerificationModal}
                    onClose={closeVerificationModal}
                    maxWidth='sm'
                    fullWidth={true}
                    aria-labelledby='simple-modal-title'
                    aria-describedby='simple-modal-description'
                    className={classes.root}
                >
                    <DialogContent>
                        <Inquiry
                            templateId={PersonaTemplateId}
                            environment={PersonaEnvironment}
                            // The webhook uses this to tie the inquiry to this user.
                            referenceId={userStore.userId}
                            onLoad={() => {
                                console.log('Loaded Persona Verification inline');
                                console.log(person);
                            }}
                            onComplete={({ inquiryId, status, fields }) => {
                                // Inquiry completed. Optionally tell your server about it.
                                if (status === 'completed') {
                                    closeModal();
                                    uiStore.hideLoading();
                                }
                            }}
                            // Whether the ID matches the profile is decided on the server (Persona webhook,
                            // `enable-id-verify-match` flag). The browser does not compare or decline.
                            onEvent={(name, meta) => {
                                switch (name as any) {
                                    case 'start': {
                                        if (meta && meta.inquiryId) {
                                            idVerificationStore
                                                .updatePersonaIDVerification(
                                                    meta.inquiryId as string,
                                                )
                                                .then(() => {
                                                    // setInquiryId(meta.inquiryId as string);
                                                });
                                        }
                                        break;
                                    }
                                }
                            }}
                            onError={(error) => {
                                console.error(`Identity Verification Error`, error);
                            }}
                            onCancel={({ inquiryId, sessionToken }) =>
                                console.log('Identity Verification Cancelled')
                            }
                            fields={{
                                nameFirst: person.firstname,
                                nameLast: person.lastname,
                                birthdate: `${person.dob.year}-${String(person.dob.month).padStart(2, '0')}-${String(person.dob.day).padStart(2, '0')}`,
                            }}
                        />
                    </DialogContent>
                </Dialog>
            </>
        );
    },
);
